import { SyntheticEvent, useCallback, useMemo } from "react";

import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";
import { Agreement } from "@is/types";

type Props = {
  agreement: Agreement;
  onOpenExternalPage: (src: string) => void;
  onToggleCheckbox: (id: string) => void;
};

const useManageAgreementItem = ({
  agreement,
  onToggleCheckbox,
  onOpenExternalPage,
}: Props) => {
  const locale = LocalStorageService.getItem(LocalStorageKeys.LanguageCode);

  const language = useMemo(() => {
    if (Object.keys(agreement?.translations).includes(locale)) {
      return locale;
    }

    return agreement?.fallbackLanguage?.code;
  }, [agreement, locale]);

  const translation = useMemo(() => {
    if (!agreement?.translations) {
      return "";
    }
    return agreement?.translations[language]?.translation || "";
  }, [agreement, language]);

  const handleToggle = useCallback(() => {
    onToggleCheckbox(agreement.id);
  }, [agreement, onToggleCheckbox]);

  const handleClick = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      const link = e.currentTarget.attributes["href"].value;

      !!link && onOpenExternalPage(link);
    },
    [onOpenExternalPage]
  );

  return { translation, handleToggle, handleClick };
};

export default useManageAgreementItem;
